module.exports = __webpack_public_path__ + "img/6.95b285f2.jpg";